import { Component } from "react"

/* Redux */
import { connect } from "react-redux"

/* Components */
import { Layout, Input } from "../../components"

/* REST API */
import { permissions, create } from "../../api/Role"

/* Icons */
import { LoadingOutlined } from "@ant-design/icons"

/* Helpers */
import { utils, withRouter } from "../../helpers"

/* Swal */
import Swal from "sweetalert2"

/* Translate */
import { t } from "../../translates/translate"



/* Page Role Create */
class RoleCreate extends Component {

    constructor() {
        super()

        this.state = {
            data: [],
            status: "loading",
            name: "",
            checked: [],
            waiting: false,
        }
    }

    componentDidMount = () => {
        this.load()
    }

    /* Load Permissions */
    load = (reload = false) => {

        if (reload) {
            this.setState({ status: "loading" })
        }

        permissions().then((response) => {
            if (response.status === 200) {
                this.setState({ status: "ok", data: response.data })
            }
            else if (response.status === 401 || response.status === 403) {
                this.setState({ status: "permission", data: [] })
            }
            else if (response.status === 498) {
                this.setState({ status: "key", data: [] })
            }
            else {
                this.setState({ status: "error", data: [] })
            }
        }).catch(() => {
            this.setState({ status: "network", data: [] })
        })

    }

    /* Permissions group */
    permissions = () => {

        const { data } = this.state

        const types = []

        data.forEach((item) => {

            const index = types.findIndex((e) => e.type === item.type)

            if (index === -1) {
                types.push({ type: item.type, list: [] })
            }

        })


        data.forEach((item) => {

            const index = types.findIndex((e) => e.type === item.type)

            if (index > -1) {
                types[index].list.push({ id: item.id, name: item.name, text: item.text })
            }

        })

        return types
    }

    /* Determine */
    findPermission = (item) => {

        const { checked } = this.state

        const index = checked.findIndex((e) => e.name === item.name)

        return index > -1
    }

    /* Add */
    togglePermission = (item, type, action) => {

        const { checked } = this.state
        const list = checked


        if (type === "item") {

            const index = checked.findIndex((e) => e.name === item.name)

            if (index > -1) {
                list.splice(index, 1)
                this.setState({ checked: list })
            }
            else {
                list.push(item)
                this.setState({ checked: list })
            }

        }


        if (type === "list" && Array.isArray(item)) {

            item.forEach((permission) => {

                const index = checked.findIndex((e) => e.name === permission.name)

                if (index > -1 && action === "clear") {
                    list.splice(index, 1)
                }

                if (index === -1 && action === "add") {
                    list.push(permission)
                }

            })

            this.setState({ checked: list })

        }

    }


    /* Save acton */
    save = () => {

        const { name, checked } = this.state
        const { navigate } = this.props

        if (name === "") {
            this._name.error(t("role.error.emptyName"))
            return
        }

        create({ name, checked }).then((response) => {
            if (response.status === 200) {
                Swal.fire(utils.notification(t("role.addedSuccess"), "success")).then(() => {
                    navigate(-1)
                })
            }
            else if (response.status === 401 || response.status === 403) {
                Swal.fire(utils.notification(t("swal.noAccess"), "error"))
            }
            else if (response.status === 498) {
                Swal.fire(utils.notification(t("swal.invalidKey"), "error"))
            }
            else {
                Swal.fire(utils.notification(t("swal.generic"), "error"))
            }
        }).catch(() => {
            Swal.fire(utils.notification(t("swal.generic"), "error"))
        }).finally(() => {
            this.setState({ waiting: false })
        })

    }


    /* Draw button */
    _button = () => {

        const { waiting } = this.state

        if (waiting) {
            return <div className="button"><LoadingOutlined /></div>
        }

        return <div onClick={() => this.save()} className="button">{t("common.save")}</div>
    }

    render = () => {

        const { status, name } = this.state

        if (status !== "ok") {
            return <Layout status={status} reload={() => this.load(true)} />
        }

        const permissions = this.permissions()

        return (
            <div className="page">

                <div className="page-header">
                    <h1>{t("role.addTitle")}</h1>
                </div>

                <div className="page-form">

                    <div className="form">
                        <div className="form-box">
                            <Input ref={(ref) => this._name = ref} label={t("role.name")} value={name} onChange={(event) => this.setState({ name: event.target.value })} />
                        </div>
                    </div>

                    <div className="permissions">
                        {permissions.map((item, index) =>
                            <div key={`${index}`} className="permission">

                                <div className="permission-type">
                                    {t("role.accessTo")} <span>{item.type}</span>
                                    <div className="permission-actions">
                                        <div onClick={() => this.togglePermission(item.list, "list", "add")} className="permission-action">{t("common.selectAll")}</div>
                                        <div onClick={() => this.togglePermission(item.list, "list", "clear")} className="permission-action">{t("common.clearAll")}</div>
                                    </div>
                                </div>

                                {item.list.map((p, i) =>
                                    <label className="permission-box" key={`${i}`}>
                                        <input type="checkbox" checked={this.findPermission(p)} onChange={() => this.togglePermission(p, "item")} />
                                        <div className="permission-name">
                                            <div className="permission-title">{p.text}</div>
                                            <div className="permission-text">{p.name}</div>
                                        </div>
                                    </label>
                                )}

                            </div>
                        )}
                    </div>

                    <div className="form-bottom form-bottom-full">
                        {this._button()}
                    </div>

                </div>


            </div>
        )
    }

}

const mapStateToProps = (state) => ({
    language: state.language,
})

export default connect(mapStateToProps)(withRouter(RoleCreate))
